export const isRatingVisible = (rate?: number | null, ratesCount?: number | null) => {
    if (!rate) return false

    const isLegacyRating = ratesCount !== null

    if (isLegacyRating && typeof ratesCount === 'number' && ratesCount < 3) return false

    return true
}
